/**
 * The feature-flag map: the single place a feature is declared finished or not.
 *
 * A feature flag is a BUILD GATE, not a user setting and not a rollout: `false`
 * means "this feature is not finished, hide every surface that belongs to it,
 * for everyone." Flipping one is a code change and a release. Values are plain
 * booleans on purpose; there is no per-environment map and no remote source.
 * See CONTEXT.md ("Feature flag" / "Rollout").
 *
 * DO NOT import this file outside `src/features/feature-flags/`. Consumers go
 * through `useFeatureFlag` / `useFeatureFlags` / `isFeatureEnabled` so the
 * source can change later without touching them. ESLint enforces this.
 */
export const FEATURE_FLAGS = {
  /** Notification category preferences. Stored, but nothing delivers yet. */
  notificationSettings: false,
  /** Reduce Motion device setting. Stored, but no animation honors it yet. */
  reduceMotion: false,
  /** Account Information screen. Not built. */
  accountInformation: false,
  /** Help Center screen. Not built. */
  helpCenter: false,
  /** About screen. Not built. */
  about: false,
} satisfies Record<string, boolean>;
// Deliberately NOT `as const`: literal `false` types would make
// `FEATURE_FLAGS[flag] === true` a TS2367 "no overlap" compile error.

/** The set of known flag names. A typo is a compile error. */
export type FeatureFlag = keyof typeof FEATURE_FLAGS;
